<template>
  <div>
    <highcharts class="hc" :options="chartOptions" ref="chart"></highcharts>
  </div>
</template>
  <script src="https://code.highcharts.com/highcharts.js"></script>
  <script>
import { Chart } from 'highcharts-vue';
import Highcharts from 'highcharts';
import exportingInit from 'highcharts/modules/exporting';
import accessibilityInit from 'highcharts/modules/accessibility';
import exportdataInit from 'highcharts/modules/export-data';
import dataInit from 'highcharts/modules/data';
import highchartsMore from 'highcharts/highcharts-more';
import highChartsJs from './highChartsJs'

exportingInit(Highcharts);
accessibilityInit(Highcharts);
exportdataInit(Highcharts);
dataInit(Highcharts);
highchartsMore(Highcharts);
export default {
  name: 'high-charts',
  components: {
    highcharts: Chart
  },
  mixins: [highChartsJs],
  props: {
    highChartsData: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      chartOptions: this.graph(this.highChartsData)
    };
  }
};
</script>
  